<template>
  <div>
    <div class="home">
      <hd></hd>
      <banner class="content banner"></banner>
      <task class="content task"></task>
      <shop class="content shop"></shop>
      <buyer :screenWidths="screenWidth" class="content buyer"></buyer>
      <mobilefooter v-if="mobiletype"></mobilefooter>
      <ft v-else></ft>
      <GlobalDialogs></GlobalDialogs>
      <div class="bind">
      <el-dialog :lock-scroll="true" v-if="bindVisible" width="60% !important" :visible.sync="bindVisible" @close="bindVisible=false">
        <div class="passport" >
          <h2 class="text-center">此微信已经绑定账号 {{userInfo.username}}</h2>
      </div>
      </el-dialog>
      </div>
    </div>
    <!--悬浮窗-->
    <floating-window></floating-window>
    <!-- <FloatingChat></FloatingChat> -->
  </div>
</template>

<script>
import api from '../../services/api.js'
import hd from '../../components/Header'
import ft from '../../components/Footer'
import banner from './Banner'
import shop from './ShopList'
import buyer from './Buyer'
import task from './Task'
import GlobalDialogs from '../../components/GlobalDialogs'
import mobilefooter from '../../components/mobilefooter'
import FloatingWindow from '../../components/FloatingWindow'
import FloatingChat from '../../components/FloatingChat'

let $ = require('jQuery')

export default {
  name: 'Home',
  components: {
    FloatingWindow,
    FloatingChat,
    mobilefooter: mobilefooter,
    hd: hd,
    banner: banner,
    task: task,
    shop: shop,
    buyer: buyer,
    ft: ft,
    GlobalDialogs: GlobalDialogs
  },
  data() {
    return {
      bindVisible: false,
      userInfo: {},
      mobiletype: false,
      screenWidth: document.body.clientWidth,
    }
  },
  created () {
    if (document.body.clientWidth < 1024) {
      this.mobiletype = true
    }
    if(this.$route.query.random_string){
      this.bindVisible = true
      this.getUserInfo()
    }else{
      this.bindVisible = false
    }
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()

    }
  },
  methods: {
    async getUserInfo () {
      let { body } = await api.getUserInfo(this)
      let result = body.result
      this.userInfo = result
    },
  },
  watch: {
    screenWidth (val) {
      if (!this.timer) {
        this.screenWidth = val
        console.log(val)
        if (val < 1024) {
          this.mobiletype = true
        }
        else {
          this.mobiletype = false
        }
        this.timer = true
        let that = this
        setTimeout(function () {
          // that.screenWidth = tha t.$store.state.canvasWidth
          that.timer = false
        }, 400)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .home{
    z-index: 99;
  }
  .banner {
  }
  .task {
  }

  .shop {
  }

  .buyer {
  }

  .ft {

  }
  .Mobilefooter  {

  }

  @media (max-width: 768px) {
    .banner {
    }
    .Mobilefooter  {
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/Index.vue